module.exports = __webpack_public_path__ + "trademark4.png?472c32f6b357f8f256fc4ca1f21ce922";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark4.png
// module id = 504
// module chunks = 0